import React from 'react';
import { TopHeaderNav } from './TopHeaderNav';
import { TopHeader } from './TopHeader';
import { CollectionNavigation } from '../CollectionNavigation';
import { useMediaQuery, useTheme } from '@mui/material';
import { HeaderMobile } from './MobileView/HeaderMobile';

const Header: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {isMobile && (
                <>
                    <HeaderMobile />
                </>
            )}
            {!isMobile && (
                <>
                    <TopHeaderNav />
                    <TopHeader />
                    <CollectionNavigation />
                </>
            )}
        </>
    );
};

export default React.memo(Header);
